export class admCatOccupationDetails {
}